import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { clearViews, getViews } from '../../../../actions/security/View';

export const ViewSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearViews,
  dispatchGetViews,
  ...rest
}) => {

  useLayoutEffect(() => () => dispatchGetViews(), []); 

  const handleInputChange = (inputValue) => {
    if (inputValue.trim().length && inputValue.trim().length >= 3) {
      let query = [`name:${inputValue}`];
      if(inputValue.slice(0,1) === '/'){
        query = [`route:${inputValue}`]
      }
      dispatchGetViews({ query });
    }
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={handleInputChange}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

ViewSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetViews: PropTypes.func.isRequired,
  dispatchClearViews: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

ViewSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Buscar vistas',
};

const mapStateToProps = ({ SecurityUnit }) => ({
  options: SecurityUnit.View.getIn(['all', 'content', 'content']).map((view) => ({
    value: view.id,
    label: `${view.name} (${view.route})`,
  })),
  loading: SecurityUnit.View.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetViews: getViews,
  dispatchClearViews: clearViews,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSelect);
